import { faPlus } from '@fortawesome/free-solid-svg-icons';
import React, { useMemo, useState } from 'react';

import useGetRequest from '../../api/useGetRequest';
import MainButton from '../../components/agv-button';
import Datatable from '../../components/agv-datatable';
import GenericPageContainer from '../../components/agv-generic-page-container';
import SearchFilter from '../../components/agv-header-search';

export default function ClientsList({ onCreate, onEdit }) {
  const [query, setQuery] = useState('');

  const { data, isLoading, isFirstLoad } = useGetRequest(
    '/super-admin/clients',
    0
  );

  const clients = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();

    return (data?.clients || [])
      .filter(
        (client) =>
          !normalizedQuery ||
          client.name?.toLowerCase().includes(normalizedQuery) ||
          String(client.client_id).includes(normalizedQuery)
      )
      .sort((a, b) => b.client_id - a.client_id);
  }, [data, query]);

  return (
    <GenericPageContainer
      title="Clients"
      subtitle="Outil interne (SUPER-ADMIN Akanéa) : création et paramétrage des clients Fleet"
      filters={
        <>
          <SearchFilter value={query} setValue={setQuery} />
          <MainButton icon={faPlus} text="Nouveau client" onClick={onCreate} />
        </>
      }
    >
      <Datatable
        isLoading={isLoading}
        isFirstLoading={isFirstLoad && isLoading}
        header={['ID', 'Client', 'Usines', '']}
        data={clients}
        values={(client) => [
          <span key={`${client.client_id}_id`} className="tw-text-slate-600">
            {client.client_id}
          </span>,
          <span
            key={`${client.client_id}_name`}
            className="tw-font-medium tw-text-slate-900"
          >
            {client.name}
          </span>,
          <span
            key={`${client.client_id}_factories`}
            className="tw-text-slate-600"
          >
            {client.factories?.length
              ? client.factories.map((factory) => factory.name).join(', ')
              : '—'}
          </span>,
          <div
            key={`${client.client_id}_action`}
            className="tw-flex tw-justify-end"
          >
            <MainButton
              variant="secondary"
              text="Paramétrer"
              onClick={() => onEdit(client.client_id)}
            />
          </div>,
        ]}
      />
    </GenericPageContainer>
  );
}
